import { FormControlLabel, MenuItem, Stack, Switch, TextField } from '@mui/material';
import { WizardValues } from './wizardTypes';

interface Step5Props {
  values: WizardValues;
  setField: <K extends keyof WizardValues>(field: K, value: WizardValues[K]) => void;
}

const INCOME_RANGES = ['Below 50,000', '50,000–100,000', '100,000–200,000', '200,000–500,000', 'Above 500,000'];

export const Step5Financial = ({ values, setField }: Step5Props) => (
  <Stack spacing={2}>
    <TextField
      label="Expected investment"
      type="number"
      fullWidth
      value={values.expectedInvestment}
      onChange={(e) => setField('expectedInvestment', e.target.value ? Number(e.target.value) : '')}
    />

    <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
      <TextField
        select
        label="Income range"
        fullWidth
        value={values.incomeRange}
        onChange={(e) => setField('incomeRange', e.target.value)}
      >
        <MenuItem value="">
          <em>Not specified</em>
        </MenuItem>
        {INCOME_RANGES.map((r) => (
          <MenuItem key={r} value={r}>
            {r}
          </MenuItem>
        ))}
      </TextField>
      <TextField
        label="Monthly income"
        type="number"
        fullWidth
        value={values.monthlyIncome}
        onChange={(e) => setField('monthlyIncome', e.target.value ? Number(e.target.value) : '')}
      />
    </Stack>

    <FormControlLabel
      control={
        <Switch
          checked={values.scholarshipRequired}
          onChange={(e) => setField('scholarshipRequired', e.target.checked)}
        />
      }
      label="Scholarship required"
    />

    <TextField
      select
      label="Funding source"
      fullWidth
      value={values.fundingSource}
      onChange={(e) => setField('fundingSource', e.target.value as WizardValues['fundingSource'])}
    >
      <MenuItem value="">
        <em>Not specified</em>
      </MenuItem>
      <MenuItem value="SELF">Self funding</MenuItem>
      <MenuItem value="LOAN">Loan</MenuItem>
      <MenuItem value="SPONSOR">Sponsor</MenuItem>
    </TextField>

    {values.fundingSource === 'SPONSOR' && (
      <TextField
        label="Sponsor details"
        fullWidth
        multiline
        minRows={2}
        value={values.sponsorDetails}
        onChange={(e) => setField('sponsorDetails', e.target.value)}
      />
    )}
  </Stack>
);
